import { formatSignedPrice } from "@/Helpers/formatSignedPrice";

interface InvoiceSectionProps {
  sectionTitle: string;
  totalCost: number;
  /** Undefined when the month mixes currencies, so no single code describes the total. */
  currency: string | undefined;
  shipmentCount: number;
}

// Month header above each month's invoices table.
function InvoicesSection(props: InvoiceSectionProps) {
  function shipmentCountDescription() {
    if (props.shipmentCount >= 3) {
      return `, ${props.shipmentCount} shipments`;
    } else {
      return ``;
    }
  }

  return (
    <div className="mt-6 mb-2 flex w-full flex-row items-center justify-between">
      <div className="flex flex-col items-start">
        <h2 className="text-[18px] font-medium text-foreground">
          {props.sectionTitle}
        </h2>
        {/* No negative top margin: it pulled the total up under the month and
            the two ran together. */}
        <div className="mt-0.5 mb-2 text-sm text-content-muted">
          {/* Still able to go negative - a month whose charge was voided but
              whose refund stands nets below zero - so the amount is formatted
              rather than prefixed with a minus. */}
          Total Spend: {formatSignedPrice(props.totalCost)}
          {props.currency ? ` ${props.currency}` : ""}
          {shipmentCountDescription()}
        </div>
      </div>
    </div>
  );
}
export default InvoicesSection;
